'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader

const actions = {
  getTaskAssignmentConfigCMS(context, params = {}) {
    const defaultData = {assingeeList: []}
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/taskassignment/getconfigcms`
        const result = await axios.get(url, {
          ...costumHeader('Get Task Assignment Config CMS', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getTaskAssignmentAssignee(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/taskassignment/gettaskassignee`
        const result = await axios.get(url, {
          ...costumHeader('Get Task Assignment Assignee', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getTaskAssignmentByRole(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/taskassignment/category/byrole/`
        const result = await axios.get(url, {
          ...costumHeader('Get Task Assignment by role', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getTaskAssignmentReport(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/taskassignment/reports`
        const result = await axios.get(url, {
          ...costumHeader('Get Task Assignment Report', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getTaskAssignment(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/taskassignment/category`
        const result = await axios.get(url, {
          ...costumHeader('Get Task Assignment', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  saveTaskAssignment(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/taskassignment/category/add`
        const result = await axios.post(url, body, costumHeader('Save Task Assignment', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  saveTaskAssignmentMultiAssignee(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/taskassignment/add/multiassignee`
        const result = await axios.post(url, body, costumHeader('Save Task Assignment Multi Assignee', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editTaskAssignment(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/taskassignment/category/edit/${body.id}`
        delete body.id
        const result = await axios.put(url, body, costumHeader('Edit Task Assignment', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteTaskAssignment(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/taskassignment/category/delete/${body.id}`
        const result = await axios.delete(url, body, costumHeader('Delete Task Assignment', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  }
}

export default { actions }